/**
 * Catégories d'annonce.
 *
 * Jeu volontairement ouvert côté serveur : il s'enrichira sans que la mécanique
 * d'affichage change. Ne jamais supposer la liste exhaustive — le modèle
 * `Announcement` prévoit un rendu par défaut pour une catégorie inconnue.
 */
export enum AnnouncementCategoryEnum {
    PRODUCT_NEWS = 'PRODUCT_NEWS',
    MAINTENANCE = 'MAINTENANCE',
    INCIDENT = 'INCIDENT',
}
